import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  bigTooltip: {
    fontSize: 16,
    padding: '12px 16px',
    maxWidth: 420,
    lineHeight: 1.4,
  },
  buttonCheck: {
    display: 'flex',
    gap: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionButton: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
    transition: 'opacity 0.3s ease',
  },
  disabledActionButton: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  dialogPaper: {
    borderRadius: '12px',
    padding: theme.spacing(2),
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    display: 'table',
    '@media (max-width: 768px)': {
      display: 'none',
    },
  },
  mobileOnly: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'block',
      padding: '16px',
    },
  },
  thead: {
    backgroundColor: '#f5f5f5',
  },
  th: {
    textAlign: 'left',
    padding: '10px',
    fontWeight: 'bold',
    borderBottom: '1px solid #ddd',
  },
  td: {
    padding: '10px',
    textAlign: 'left',
    borderBottom: '1px solid #eee',
    fontSize: 14,
  },
  catalogCell: {
    textAlign: 'left',
    '& .MuiInputBase-root': {
      width: '100%',
    },
  },
  characteristics: {
    fontFamily: 'Red Hat Display regular',
  },
  switch: {
    width: '40px',
    height: '20px',
    backgroundColor: '#bbb',
    borderRadius: '10px',
    display: 'inline-block',
    position: 'relative',
  },
  switchDot: {
    width: '16px',
    height: '16px',
    backgroundColor: '#fff',
    borderRadius: '50%',
    position: 'absolute',
    top: '2px',
    left: '2px',
  },
  switchOn: {
    backgroundColor: '#6366f1',
  },
  switchDotOn: {
    left: '22px',
  },
  rejectedText: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#111',
  },
  rejectedNote: {
    fontSize: '11px',
    color: '#999',
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
  },
  cardLogoText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
  },
  trStyles: {
    height: 70,
    '&:hover': {
      backgroundColor: '#EDEDFF',
    },
  },
  paginationBusiness: {
    display: 'flex',
    justifyContent: 'end',
  },
  card: {
    padding: '0 16px',
    marginBottom: 12,
    backgroundColor: '#fff',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 14,
    cursor: 'pointer',
    width: '100%',
  },
  body: {
    marginTop: 16,
    padding: '0 14px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  iconAndLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  icon: {
    width: 20,
    height: 20,
  },
  status: {
    fontSize: 13,
  },
  accepted: {
    color: 'green',
  },
  rejected: {
    color: 'red',
  },
  headerContainer: {
    borderRadius: 12,
    overflow: 'hidden',
    border: '1px solid #ddd',
    marginBottom: 12,
  },

  activeHeader: {
    backgroundColor: '#EEF0FF',
  },
  headerButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '12px 16px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
  },

  headerText: {
    fontWeight: 600,
    fontSize: 14,
    color: '#111',
  },

  headerIcon: {
    fontSize: 16,
  },
  moreInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    justifyContent: 'center',
  },
  buttonOutlined: {
    width: '248px',
    height: '40px',
    margin: '20px 0',
    borderRadius: '50px',
    border: '1px solid #6064FF',
    color: '#6064FF',
    fontWeight: '500',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      fontWeight: 'bolder',
      color: '#FF40FC',
      border: '1px solid #FF40FC',
      borderRadius: '50px',
    },
  },
  mobileTable: {
    width: '100%',
    overflowX: 'auto',
  },
  mobileHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 80px',
    gap: '8px',
    padding: '12px 8px',
    backgroundColor: '#F5F5F5',
    fontWeight: 600,
    fontSize: '14px',
  },
  mobileHeaderCell: {
    padding: '8px',
    color: '#333',
  },
  mobileRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 80px',
    gap: '8px',
    padding: '12px 8px',
    borderBottom: '1px solid #E8E8E8',
    alignItems: 'center',
  },
  mobileCell: {
    padding: '8px',
    fontSize: '14px',
  },
  businessItem: {
    marginBottom: '8px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  headerContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontFamily: 'Red Hat Display Regular',
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 410,
    height: 48,
    border: '2px solid #7A7A7A',
    borderRadius: 8,
    boxShadow: 'none',
    position: 'relative',
    marginBottom: 10,
  },
  select: {
    minHeight: 32,
    height: 32,
    fontSize: 14,
    borderRadius: 8,
    padding: 0,
    '& .MuiSelect-select': {
      padding: '4px 8px !important',
      display: 'flex',
      alignItems: 'center',
    },
  },
  tdNoData: {
    textAlign: 'center',
  },
}))
